import Vue from "vue";
import _ from "lodash";
import { uploadFile, uploadPolicies } from "@/api/base";
import { EXIF } from "@/plugins/small-exif.js";

export default Vue.extend({
    data() {
        return {
            uploadPolicies: {
                byteSizeLimit: 0,
                formatSizeLimit: "",
                mimeTypesLimit: "image/*"
            }
        };
    },
    mounted() {
        uploadPolicies().then(resp => {
            const policies = resp.data.data;
            this.uploadPolicies.byteSizeLimit = policies.byteSizeLimit;
            this.uploadPolicies.formatSizeLimit = policies.formatSizeLimit;
        });
    },
    methods: {
        onOversize() {
            this.$toast(this.$t("upload.uploadMaxSizeError", [this.uploadPolicies.formatSizeLimit]));
        },
        onClickPreview() {
            if (this.$route.hash !== "#preview") {
                this.$router.push({ path: this.$route.path, hash: "preview" }).catch();
            }
        },
        onClosePreview() {
            // 点击遮罩层关闭时，不会改变url，需要手动back
            if (this.$route.hash === "#preview") {
                this.$router.back();
            }
        },
        reReadImage(file, canvasCallback) {
            let Orientation = null;
            const image: any = new Image();
            const reader = new FileReader();
            reader.onload = function(ev) {
                // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
                // @ts-ignore
                image.src = ev.target.result;
            };
            image.onload = function() {
                const imgWidth = this.naturalWidth,
                    imgHeight = this.naturalHeight;

                const canvas = document.createElement("canvas");
                const ctx = canvas.getContext("2d");
                canvas.width = imgWidth;
                canvas.height = imgHeight;
                if (Orientation && Orientation != 1 && ctx) {
                    switch (Number(Orientation)) {
                        case 6:
                            canvas.width = imgHeight;
                            canvas.height = imgWidth;
                            ctx.rotate(Math.PI / 2);
                            ctx.drawImage(image, 0, -imgHeight, imgWidth, imgHeight);
                            break;
                        case 3:
                            ctx.rotate(Math.PI);
                            ctx.drawImage(image, -imgWidth, -imgHeight, imgWidth, imgHeight);
                            break;
                        case 8:
                            canvas.width = imgHeight;
                            canvas.height = imgWidth;
                            ctx.rotate((Math.PI * 3) / 2);
                            ctx.drawImage(image, -imgWidth, 0, imgWidth, imgHeight);
                            break;
                    }
                } else if (ctx) {
                    ctx.drawImage(image, 0, 0, imgWidth, imgHeight);
                }
                canvasCallback(canvas);
            };
            if (file) {
                EXIF.getData(file, img => {
                    Orientation = EXIF.getTag(img, "Orientation");
                    reader.readAsDataURL(file);
                });
            }
        },
        dataURLtoFile(dataurl, filename) {
            const arr = dataurl.split(","),
                mime = arr[0].match(/:(.*?);/)[1],
                bstr = atob(arr[1]);
            let n = bstr.length;
            const u8arr = new Uint8Array(n);
            while (n--) {
                u8arr[n] = bstr.charCodeAt(n);
            }
            return new File([u8arr], filename, { type: mime });
        },
        afterRead(file, externalUploadData, callback, onUploadCompleted: () => void) {
            this.reReadImage(file.file, canvas => {
                file.file = this.dataURLtoFile(canvas.toDataURL(file.file.type, 1), file.file.name);
                file.status = "uploading";
                file.message = this.$t("upload.uploading");
                const formData = new FormData();
                formData.append("file", file.file);
                formData.append("businessType", externalUploadData.businessType);
                if (!_.isEmpty(externalUploadData.prefixFileName)) {
                    formData.append("prefixFileName", externalUploadData.prefixFileName);
                }
                if (!_.isUndefined(externalUploadData.businessId)) {
                    formData.append("businessId", externalUploadData.businessId);
                }
                uploadFile(formData)
                    .then(resp => {
                        const data = resp.data.data;
                        file.status = "done";
                        callback(data.fileKey, data.downloadUrl, data.thumbnailUrl);
                    })
                    .catch(error => {
                        file.status = "failed";
                        file.message = this.$t("upload.uploadFailed");
                    })
                    .finally(() => {
                        onUploadCompleted();
                    });
            });
        }
    }
});
